import React from "react";
import { Badge } from "../Badge";
import Tooltip from "components/Tooltip";
import { formattedDate, formattedSimpleDate } from "utils/dateFormat";
import { isRFQDraft } from "utils/helpers";
import { hasInviteeSubmittedRfx } from "helpers/rfxHelper";
import { getRfxStatusPresentation } from "newui/features/Rfx/utils/rfx-status-colour";
const StatusBadge = ({ status, submittedDateTime, rfqStatus }) => {
	const statusType = status?.toUpperCase();
	const isDraft = isRFQDraft(rfqStatus);
	// The status→colour switch that used to live here now lives in
	// `getRfxStatusPresentation` so the RFx card's top border renders the same
	// colour as this badge from the same table, instead of a copy that drifts.
	const { colour: colorStatus, text: statusText } = getRfxStatusPresentation(
		status,
		isDraft
	);

	const hasSubmitted = hasInviteeSubmittedRfx(status);

	return (
		<div className="flex flex-wrap items-center gap-1">
			<Tooltip
				label={
					hasSubmitted && `Submitted on: ${formattedDate(submittedDateTime)}`
				}
				placement="top-start"
				hasArrow
			>
				<Badge color={colorStatus}>
					<p className="font-roboto text-sm font-medium capitalize leading-5">
						{statusText}
					</p>
				</Badge>
				{statusType === "SUBMITTED" && (
					<div class="block w-full pl-3 text-left text-[12px]">
						{formattedSimpleDate(submittedDateTime)}
					</div>
				)}
			</Tooltip>
		</div>
	);
};

export default StatusBadge;
